import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <img src="/assets/1474.gif" alt="loader" />
    </div>
  );
};

export default Loader;